import React from 'react';
import { useSelector } from 'react-redux';
import { Row, Column, Divider, List, ListItem } from '@vp/swan';

import { CartItem } from './CartItem';
import { ItemModWrapper } from '../uxMods/ItemModWrapper';
import { CartItemGroup } from './CartItemGroup';
import { cartItemSelectors } from '../../state/cartItems';
import { ItemGroupModWrapper } from '../uxMods/ItemGroupModWrapper';

export const CartItems = () => {
  const cartItemDisplayGroups = useSelector(state =>
    cartItemSelectors.selectCartItemDisplayGroups(state.cartItems)
  );

  return (
    <Row>
      <Column span={12} className="cart-items-container">
        <List skin="minimal" mt={6}>
          {cartItemDisplayGroups.map((cartItemDisplayGroup, index) => (
            <ListItem key={index}>
              {cartItemDisplayGroup.groupId ? (
                <ItemGroupModWrapper
                  groupId={cartItemDisplayGroup.groupId}
                  key={`itemGroup-${cartItemDisplayGroup.groupId}`}
                >
                  <CartItemGroup
                    cartItemIds={cartItemDisplayGroup.cartItemIds}
                    groupId={cartItemDisplayGroup.groupId}
                  />
                </ItemGroupModWrapper>
              ) : (
                <ItemModWrapper
                  itemId={cartItemDisplayGroup.cartItemIds[0]}
                  key={`item-${cartItemDisplayGroup.cartItemIds[0]}`}
                >
                  <CartItem cartItemId={cartItemDisplayGroup.cartItemIds[0]} />
                </ItemModWrapper>
              )}
              <Divider marginY={6} />
            </ListItem>
          ))}
        </List>
      </Column>
    </Row>
  );
};
